import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { formatPrice, statusColor, statusLabel } from '../../utils/helpers';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats').then(({ data }) => setStats(data)).finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '80px' }}>
      <div className="spinner" />
    </div>
  );

  return (
    <div className="admin-dashboard">
      <div className="admin-page-title">Dashboard Overview</div>
      <p className="admin-page-sub">Welcome back! Here's what's happening with NORIX today.</p>

      {/* Stat Cards */}
      <div className="stat-grid">
        <div className="stat-card purple">
          <span className="stat-icon">📦</span>
          <div className="stat-label">Total Orders</div>
          <div className="stat-value">{stats?.totalOrders || 0}</div>
        </div>
        <div className="stat-card pink">
          <span className="stat-icon">💰</span>
          <div className="stat-label">Total Revenue</div>
          <div className="stat-value">{formatPrice(stats?.totalRevenue || 0)}</div>
        </div>
        <div className="stat-card green">
          <span className="stat-icon">👕</span>
          <div className="stat-label">Total Products</div>
          <div className="stat-value">{stats?.totalProducts || 0}</div>
        </div>
        <div className="stat-card blue">
          <span className="stat-icon">👥</span>
          <div className="stat-label">Total Users</div>
          <div className="stat-value">{stats?.totalUsers || 0}</div>
        </div>
      </div>

      {/* Second row */}
      <div className="dash-grid">
        {/* Recent Orders */}
        <div className="admin-table-wrap">
          <div className="table-header">
            <span className="table-title">Recent Orders</span>
            <Link to="/admin/orders" className="btn btn-outline" style={{ padding: '6px 16px', fontSize: '0.82rem' }}>View All</Link>
          </div>
          <table className="admin-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Total</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {stats?.recentOrders?.map(order => (
                <tr key={order._id}>
                  <td>
                    <Link to={`/admin/orders/${order._id}`} className="order-id-link">
                      #{order._id.slice(-6).toUpperCase()}
                    </Link>
                  </td>
                  <td>{order.user?.name || 'N/A'}</td>
                  <td className="price-cell">{formatPrice(order.totalPrice)}</td>
                  <td><span className={`badge ${statusColor(order.orderStatus)}`}>{statusLabel(order.orderStatus)}</span></td>
                  <td className="date-cell">{new Date(order.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {(!stats?.recentOrders || stats.recentOrders.length === 0) && (
            <div className="table-empty">No orders yet</div>
          )}
        </div>

        {/* Quick Stats */}
        <div className="quick-stats">
          <div className="qs-card card">
            <div className="qs-icon">⏳</div>
            <div className="qs-label">Pending Orders</div>
            <div className="qs-val">{stats?.pendingOrders || 0}</div>
            <Link to="/admin/orders?status=processing" className="qs-link">View →</Link>
          </div>

          <div className="quick-actions card">
            <h3>Quick Actions</h3>
            <Link to="/admin/products/new" className="btn btn-primary qa-btn">+ Add Product</Link>
            <Link to="/admin/orders" className="btn btn-outline qa-btn">📦 View Orders</Link>
            <Link to="/admin/users" className="btn btn-outline qa-btn">👥 Manage Users</Link>
            <Link to="/admin/reviews" className="btn btn-outline qa-btn">⭐ Reviews</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
